import { setStorageImplementation } from '@clockout-dev/rn-ui';

// Open SSO impersonates a different user on every boot. Core's default web
// storage writes to window.localStorage with no namespace, so a previous
// user's cached settings (accountId, authAccountId, ...) would bleed into the
// next impersonation — and would sit in the same localStorage that holds the
// admin's own session (userRole, auth). Routing core's persistence into a
// plain in-memory Map, reset before each boot, gives fresh state per user and
// keeps core out of the admin's localStorage entirely.
const store = new Map();

const openSsoStorage = {
    getItem: (key) => Promise.resolve(store.has(key) ? store.get(key) : null),
    setItem: (key, value) => {
        store.set(key, String(value));
        return Promise.resolve();
    },
    removeItem: (key) => {
        store.delete(key);
        return Promise.resolve();
    },
};

// Point core at the in-memory store. Idempotent — safe to call on every boot.
export function installOpenSsoStorage() {
    setStorageImplementation(openSsoStorage);
}

// Drop everything the previous impersonation cached. Call before each boot.
export function resetOpenSsoStorage() {
    store.clear();
}
